import React from "react";
import { MobileScreenSettingsShortcuts } from "@/types/mobile-settings";
import {
  Bike,
  BookOpen,
  CircleHelp,
  ExternalLink,
  House,
  Map,
  Wifi,
} from "lucide-react";

interface ShortcutItemProps {
  shortcut: MobileScreenSettingsShortcuts;
}

export const ShortcutItem: React.FC<ShortcutItemProps> = ({ shortcut }) => {
  const getIcon = (name: string) => {
    switch (name) {
      case "Hotel Policy":
        return <BookOpen className="size-4 text-zinc-500" />;
      case "Wi-Fi":
        return <Wifi className="size-4 text-zinc-500" />;
      case "Special Services":
        return <House className="size-4 text-zinc-500" />;
      case "Hotel Amenities":
        return <Map className="size-4 text-zinc-500" />;
      case "Activities":
        return <Bike className="size-4 text-zinc-500" />;
      case "FAQs":
        return <CircleHelp className="size-4 text-zinc-500" />;
      default:
        return <ExternalLink className="size-4 text-zinc-500" />;
    }
  };

  return (
    <div className="flex min-w-[120px] items-center gap-2 rounded-md border border-zinc-200 bg-zinc-100 px-4 py-2">
      {getIcon(shortcut.name)}
      <span className="text-sm font-medium">{shortcut.name}</span>
    </div>
  );
};
